import React, {MouseEventHandler} from 'react'
import {Tooltip, useTheme} from '@mui/material'
import FontAwesome from 'react-fontawesome'
import {useDispatch, useSelector} from 'react-redux'
import {DqButton} from 'generated/JavaTOmodifications'
import {dqButtonClickedAction} from 'module/DqButton/action/DqButtonsAction'
import {selDqButtonErrorById, selDqButtonLoading} from 'module/DqButton/selector/DqButtonSelector'
import {Cancel} from '@mui/icons-material'
import {ButtonWithIcon, ButtonWithIconProps} from 'component/ButtonWithIcon'
import {css} from '@emotion/react'
import {DqButtonParams} from 'module/DqButton/type/DqButtonParams'

interface Props extends ButtonWithIconProps {
	dqButton: DqButton
	getParams?: () => DqButtonParams
}

export function DqButtonComponent({dqButton, getParams, ...props}: Props) {
	const theme = useTheme()
	const cssError = css`
		color: ${theme.palette.error.main};
		display: flex;
		align-items: end;
	`
	const cssErrorIcon = css`
		color: ${theme.palette.error.main};
		height: 22px;
		width: 22px;
	`
	const dispatch = useDispatch()
	const loading = useSelector(selDqButtonLoading).includes(dqButton.id)
	const disabled = loading || props.disabled
	const error = useSelector(selDqButtonErrorById)[dqButton.id]
	const tooltip = (error || dqButton.tooltip) && <>
		{error && <div css={cssError}><Cancel css={cssErrorIcon}/>&nbsp;
			<div>{error}</div>
		</div>}
		{dqButton.tooltip && <div dangerouslySetInnerHTML={{__html: dqButton.tooltip}}/>}
	</>
	const onClick: MouseEventHandler = (evt) => {
		evt.stopPropagation()
		dispatch(dqButtonClickedAction({dqButton: dqButton, params: getParams && getParams()}))
	}
	const btn = <ButtonWithIcon
		{...props}
		disabled={disabled}
		loading={loading}
		icon={dqButton.icon && <FontAwesome name={dqButton.icon}/> || undefined}
		onClick={onClick}
		label={dqButton.label}
	>
	</ButtonWithIcon>
	if (tooltip) {
		return <Tooltip title={tooltip}><span>{btn}</span></Tooltip>
	} else {
		return btn
	}
}